import { apiRequest } from "@/services/api-client";
import {
  ReleasePokemonInput,
  ReleasePokemonOutput,
  WebAppRoutes,
} from "types/web-app";

export const releasePokemon = (input: ReleasePokemonInput) =>
  apiRequest<ReleasePokemonOutput>("/" + WebAppRoutes.RELEASE_POKEMON, {
    method: "POST",
    body: JSON.stringify(input),
  });
